import React from "react";
import { motion } from "framer-motion";
import {
  FaStar,
  FaComments,
  FaGlobe,
  FaUsers,
  FaClock,
  FaRocket,
  FaHandshake,
  FaDollarSign,
} from "react-icons/fa";

// Анимация заголовка
const titleVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Анимация элементов списка (поочередное появление)
const listItemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { duration: 0.4, delay: i * 0.15, ease: "easeOut" }, // Задержка для каждого элемента
  }),
};

function PricingPlans() {
  return (
    <section className="pricing" id="pricing">
      {/* Заголовок с анимацией */}
      <motion.h2
        className="pricing__title"
        variants={titleVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.8 }}
      >
        Тарифи
      </motion.h2>

      <div className="pricing__container">
        {/* Обычный тариф */}
        <div className="pricing__plan pricing__plan--standard">
          <div className="pricing__header">
            <h3 className="pricing__price">450</h3>
            <FaDollarSign className="pricing__icon-price" />
          </div>
          <p className="pricing__type">Звичайний тариф</p>
          {/* Список с анимацией элементов */}
          <ul className="pricing__list">
            {[
              { icon: <FaStar />, text: "Готові зв’язки та креативи" },
              { icon: <FaComments />, text: "Чат співбесіди потоку" },
              { icon: <FaGlobe />, text: "Інфо канал" },
              { icon: <FaUsers />, text: "Підтримка від тім-лідів" },
              { icon: <FaClock />, text: "Зідвзони 3 рази в тиждень" },
            ].map((item, index) => (
              <motion.li
                key={index}
                className="pricing__list-item"
                variants={listItemVariants}
                initial="hidden"
                whileInView="visible"
                custom={index} // Используем индекс для задержки
                viewport={{ once: false, amount: 0.8 }}
              >
                {item.icon}
                {item.text}
              </motion.li>
            ))}
          </ul>
        </div>

        {/* VIP Тариф */}
        <div className="pricing__plan pricing__plan--vip">
          <div className="pricing__header">
            <h3 className="pricing__price">850</h3>
            <FaDollarSign className="pricing__icon-price" />
          </div>
          <p className="pricing__type">VIP Тариф</p>
          {/* Список с анимацией элементов */}
          <ul className="pricing__list">
            {[
              { icon: <FaStar />, text: "Все, що є в звичайному тарифі" },
              { icon: <FaUsers />, text: "Приватний чат" },
              {
                icon: <FaComments />,
                text: "Допомога та власні зідзвони з овнером та тім-лідом",
              },
              {
                icon: <FaRocket />,
                text: "Повне навчання ефективного запуску реклами",
              },
              {
                icon: <FaHandshake />,
                text: "Гарантоване попадання у команду з приватними офферами",
              },
            ].map((item, index) => (
              <motion.li
                key={index}
                className="pricing__list-item"
                variants={listItemVariants}
                initial="hidden"
                whileInView="visible"
                custom={index} // Используем индекс для задержки
                viewport={{ once: false, amount: 0.8 }}
              >
                {item.icon}
                {item.text}
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default PricingPlans;
